import React from "react";
import { getGalleryFallbackBadge } from "../../api/galleryFallback";

function GalleryFallbackNotice({ message, source = "local", onRetry, retrying = false }) {
  if (!message) return null;

  return (
    <div className="cms-fallback-notice fpep-gallery-fallback-notice" role="status">
      <div className="cms-fallback-notice__content">
        <span className="cms-fallback-notice__badge">{getGalleryFallbackBadge(source)}</span>
        <span>{message}</span>
      </div>

      {onRetry && (
        <button
          type="button"
          className="cms-fallback-notice__retry"
          onClick={onRetry}
          disabled={retrying}
        >
          {retrying ? "Provjera..." : "Pokušaj ponovo"}
        </button>
      )}
    </div>
  );
}

export default GalleryFallbackNotice;
